import { RECOMMENDED_STORES_GET_SUCCESS, RECOMMENDED_STORES_GET_FAILURE } from '../actions/types';
import recommendedStoresConfig from '../configs';

const initialState = {
  config: recommendedStoresConfig,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

const recommendedStores = (state = initialState, action) => {
  switch (action.type) {
    case RECOMMENDED_STORES_GET_SUCCESS: {
      return {
        ...state,
        merchants: action.payload.response,
        isLoading: false,
        isLoaded: true,
      };
    }
    case RECOMMENDED_STORES_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === RECOMMENDED_STORES_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default recommendedStores;
